import { render, staticRenderFns } from "./MedLabelSingle.vue?vue&type=template&id=4c94ab42&"
import script from "./MedLabelSingle.vue?vue&type=script&lang=js&"
export * from "./MedLabelSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports